import { render, staticRenderFns } from "./Feedbacks.vue?vue&type=template&id=5375bf26&scoped=true&"
import script from "./Feedbacks.vue?vue&type=script&lang=js&"
export * from "./Feedbacks.vue?vue&type=script&lang=js&"
import style0 from "./Feedbacks.vue?vue&type=style&index=0&id=5375bf26&prod&scoped=true&lang=scss&"
import style1 from "./Feedbacks.vue?vue&type=style&index=1&id=5375bf26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5375bf26",
  null
  
)

export default component.exports